<script setup lang="ts">
import { useGeoDataStore } from '~/stores/geoData'
import { County, RegionPages } from '@/types/types'
import AppLoadingWrapper from '~/components/app/AppLoadingWrapper.vue'
definePageMeta({
  layout: 'full-width',
})

const { slug } = useRoute().params
const geoDataStore = useGeoDataStore()
const county = computed<County | undefined>(() => {
  return geoDataStore.counties.find((m) => m.slug === slug)
})
const pageCounty = computed<RegionPages>(() => geoDataStore.pageCounty)

onMounted(() => {
  geoDataStore.initCounties()
  geoDataStore.initPageCounty()
})

useSeoMeta({
  title: () =>
    `Drivmedla - ${county.value ? `Omställningskarta ${county.value.name}` : 'Omställningskarta'}`,
  description: () =>
    `Här finns karta och statistik för ${
      county.value ? county.value.name : 'regioners'
    } omställning till fossilfria alternativ`,
  ogTitle: () =>
    `Drivmedla - ${county.value ? `Omställningskarta ${county.value.name}` : 'Omställningskarta'}`,
  ogDescription: () =>
    `Här finns karta och statistik för ${
      county.value ? county.value.name : 'regioners'
    } omställning till fossilfria alternativ`,
  ogLocale: () => 'sv_SE',
  ogSiteName: () => 'Drivmedla',
  ogUrl: () => `${useRuntimeConfig().public.baseURL}${useRoute().fullPath}`,
  ogImage: () => `${useRuntimeConfig().public.baseURL}/_nuxt/assets/_logo-horizontal-GREEN.svg`,
})
</script>

<template>
  <AppLoadingWrapper :is-loading="!county" :height="20">
    <RegionView
      v-if="county"
      region-type="county"
      :region-id="county.county_code"
      :region-object="county"
      :region-content="pageCounty"
    />
  </AppLoadingWrapper>
</template>
<style scoped></style>
